<template>
	<div class="c-folder-select">
		<b-dropdown
			:id="'dropdown-' + _uid"
			class=""
			:size="size"
			boundary="window"
			:variant="type"
		>
			<template v-slot:button-content>
				<template v-if="text">
					<span>
						{{ text }}
					</span>
				</template>
				<template v-else>
					<template v-if="currentFolder">
						<span>
							{{ getTitle(selectedText) }}
						</span>
					</template>
					<template v-else>
						<span class="muted">
							{{ selectedText }}
						</span>
					</template>
				</template>
			</template>
			<b-dropdown-item
				v-for="folder in folders"
				@click="onSelect(folder)"
				:key="folder._id"
			>
				<span v-html="folder.title"></span>
			</b-dropdown-item>
			<b-dropdown-item v-if="currentFolder" @click="removeFolder">
				<span
					><x-icon size="1x"></x-icon>&nbsp;Remove from
					<span>{{ currentFolder.title }}</span></span
				>
			</b-dropdown-item>
		</b-dropdown>
	</div>
</template>

<script>
import { PlusIcon, XIcon } from 'vue-feather-icons';
export default {
	components: {
		PlusIcon,
		XIcon,
	},
	data: function () {
		var obj = {
			currentFolder: null,
		};
		return obj;
	},
	props: {
		folderId: String,
		size: String,
		text: String,
		type: {
			default: 'primary',
			type: String,
		},
	},
	watch: {
		folderId: {
			handler: function () {
				if (this.folderId) {
					this.currentFolder = this.$store.getters['folder/folder'](
						this.folderId
					);
				} else {
					this.currentFolder = null;
				}
			},
			immediate: true,
		},
	},
	computed: {
		selectedText: function () {
			var str = 'Select a folder';
			if (this.currentFolder) {
				str = this.getTitle(this.currentFolder.title, true);
			}
			return str;
		},
		folders: function () {
			return this.$store.getters['folder/folders'];
		},
	},
	created: function () {
		if (this.bucketId) {
			this.currentFolder = this.$store.getters['folder/folders'](this.bucketId);
		}
	},
	methods: {
		getTitle: function (str, short) {
			short = short || false;
			str = str.split('|');
			if (str[1]) {
				var temp2 = str[0];
				var temp = [str.shift(), str.join('|')];
				if (short) {
					return temp2;
				} else {
					return `${temp2}<span class="muted">${str}</span>`;
				}
			} else {
				return str[0];
			}
		},
		removeFolder: function () {
			this.currentFolder = '';
			this.$emit('change', null);
		},
		onSelect: function (folder) {
			this.currentFolder = folder;
			this.$emit('change', this.currentFolder);
		},
	},
};
</script>

<style lang="scss">
.c-folder-select {
	display: inline-block;
	ul {
		margin: 0;
		list-style: none;

		li {
			margin: 0;
			padding: 0;
		}
	}

	.muted {
		opacity: 0.7;
	}

	&__header {
		font-weight: 500;
		font-size: 13px;
		display: flex;
		align-items: center;
		height: 32px;
		letter-spacing: 0.2px;
		border-radius: 4px;
		padding: 2px 8px;

		.c-tooltip {
			margin-left: auto;
		}
	}
	.dropdown-item {
		.muted {
			display: block;
			font-size: $xs-font-size;
		}
	}
}
</style>
